import AddWishCard from "./AddWishCard";
import NewWishCard from "../wish/NewWishCard";
import WishCard from "../wish/WishCard";
import CategoryProductCard from "./CategoryProductCard";
import EventProductCard from "./EventProductCard";
import NewProductCard from "./NewProductCard";
import NoneCartProductCard from "./NoneCartProductCard";
import NormalProductCard from "./NormalProductCard";
import style from "./ProductCard.module.css";
import RankProductCard from "./RankProductCard";
import SimpleProductCard from "./SimpleProductCard";
import SpecialPriceCard from "./SpecialPriceCard";
import SuperDealCard from "./SuperDealCard";
import TextProductCard from "./TextProductCard";

function ProductCard(props) {
  const {
    data,
    template,
    type,
    border,
    skeleton,
    restock,
    interests,
    onWishToggle,
    rank,
  } = props;

  return (
    <div className={style.productCard}>
      {
        {
          normal: (
            <NormalProductCard
              restock={restock}
              data={data}
              type={type}
              skeleton={props.skeleton}
              rank={props.rank}
            />
          ),
          noneCart: (
            <NoneCartProductCard
              data={data}
              type={type}
              skeleton={props.skeleton}
              rank={props.rank}
            />
          ),
          rank: (
            <RankProductCard
              data={data}
              type={type}
              skeleton={props.skeleton}
              rank={props.rank}
            />
          ),
          simple: (
            <SimpleProductCard
              data={data}
              type={type}
              skeleton={props.skeleton}
            />
          ),
          text: <TextProductCard data={data} />,
          superDeal: <SuperDealCard data={data} border={border} />,
          newProduct: <NewProductCard data={data} border={border} />,
          topCategoryProduct: <CategoryProductCard data={data} />,
          flag: <SpecialPriceCard data={data} />,
          wish: <WishCard data={data} />,
          newWish: <NewWishCard data={data} />,
          addWish: (
            <AddWishCard
              restock={restock}
              data={data}
              type={type}
              skeleton={skeleton}
              rank={rank}
              interests={interests}
              onWishToggle={onWishToggle}
            />
          ),
          event: (
            <EventProductCard
              data={data}
              type={type}
              skeleton={props.skeleton}
              rank={props.rank}
            />
          ),
        }[template]
      }
    </div>
  );
}

export default ProductCard;
